import { useReducer } from "react"
import "lib/@hooks/useEvent"
import { readScheduleEditorSession } from "../lib/schedule-editor-session"
import { useScheduleEditorIds } from "./use-schedule-editor-ids"
import { DraftTokensChanged } from "../schedule-editor-event-definitions.mjs"

/** Live draft macro token ids + map. Subscribes to DraftTokensChanged only. */
export function useScheduleEditorDraftTokens() {
    const { draftId } = useScheduleEditorIds()
    const [, forceUpdate] = useReducer(tick, 0)

    DraftTokensChanged(draftId).useEvent(forceUpdate)

    const session = readScheduleEditorSession(draftId)

    return {
        draftTokenIdSet: session?.draftTokenIdSet ?? new Set(),
        draftTokenIds: session?.draftTokenIds ?? [],
        macroMap: session?.macroMap ?? {},
    }
}

function tick(n) {
    return n + 1
}
